import React, { Component } from 'react';

/*Material ui template */
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';

import purple from '@material-ui/core/colors/purple';
import Switch from '@material-ui/core/Switch';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import NumberFormat from 'react-number-format';

const styles = theme => ({
  colorSwitchBase: {
    color: purple[300],
    '&$colorChecked': {
      color: purple[500],
      '& + $colorBar': {
        backgroundColor: purple[500],
      },
    },
  },
  colorBar: {},
  colorChecked: {},
  iOSSwitchBase: {
    '&$iOSChecked': {
      color: theme.palette.common.white,
      '& + $iOSBar': {
        backgroundColor: '#52d869',
      },
    },
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.sharp,
    }),
  },
  iOSChecked: {
    transform: 'translateX(15px)',
    '& + $iOSBar': {
      opacity: 1,
      border: 'none',
    },
  },
  iOSBar: {
    borderRadius: 13,
    width: 42,
    height: 26,
    marginTop: -13,
    marginLeft: -21,
    border: 'solid 1px',
    borderColor: theme.palette.grey[400],
    backgroundColor: theme.palette.grey[50],
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border']),
  },
  iOSIcon: {
    width: 24,
    height: 24,
  },
  iOSIconChecked: {
    boxShadow: theme.shadows[1],
  },
});

function NumberFormatCustom(props) 
{
  const { inputRef, onChange, ...other } = props;
  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      decimalScale={2}
      fixedDecimalScale={true}
      onValueChange={values => {
        onChange({
          target: {
            id:props.id,
            value: values.value,
          },
        });
      }}
      thousandSeparator
    />
  );
}

class CostDetailInfo extends Component {
  

  componentDidMount()
  {

  }

  handleChange = name => event => 
  {

   this.props.handleChange({target:{value:event.target.checked?1:0,id:name}});
  }



  render() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <Typography variant="h6" gutterBottom>
          Cost Detail Information
        </Typography>
        <Grid container spacing={24}>
        <Grid item xs={12} sm={6}>
          <InputLabel htmlFor="check_deliverable" style={{marginRight:'10px'}}>Work on Saturdays</InputLabel>
           <Switch
            classes={{
              switchBase: classes.iOSSwitchBase,
              bar: classes.iOSBar,
              icon: classes.iOSIcon,
              iconChecked: classes.iOSIconChecked,
              checked: classes.iOSChecked,
            }}
            disableRipple
            checked={this.props.costinfo.saturday_selected===1?true:false}
            onChange={this.handleChange('saturday_selected')}
            value="saturday_selected"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputLabel htmlFor="check_deliverable" style={{marginRight:'10px'}}>Work on Sundays</InputLabel>
           <Switch
            classes={{
              switchBase: classes.iOSSwitchBase,
              bar: classes.iOSBar,
              icon: classes.iOSIcon,
              iconChecked: classes.iOSIconChecked,
              checked: classes.iOSChecked,
            }}
            disableRipple
            checked={this.props.costinfo.sunday_selected===1?true:false}
            onChange={this.handleChange('sunday_selected')}
            value="sunday_selected"
          />
        </Grid>
         <Grid item xs={12} sm={6}>
            <TextField
              style={{width: '90%'}}
              id="start_date"
              label="Start Date"
              type="date"
              InputLabelProps={{
                shrink: true,
              }}
              value={this.props.costinfo.start_date}
              onChange={this.props.handleChange}
              disabled={this.props.reviewActive}
              error={this.props.errores.start_date}
              helperText={this.props.errores.start_date}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              style={{width: '90%'}}
              id="finish_date"
              label="End Date"
              type="date"
              InputLabelProps={{
                shrink: true,
              }}
              value={this.props.costinfo.finish_date}
              onChange={this.props.handleChange}
              disabled={this.props.reviewActive}
              error={this.props.errores.finish_date}
              helperText={this.props.errores.finish_date}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              id="number_days"
              name="number_days"
              label="Number of Days"
              fullWidth
              autoComplete="number_days"
              value={this.props.costinfo.number_days?this.props.costinfo.number_days:0}
              disabled={true}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id="total_cost"
              label="Total Cost"
              type="text"
              value={this.props.costinfo.total_cost}
              disabled={true}
              InputProps={{
                inputComponent: NumberFormatCustom,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id="daily_cost"
              label="Daily Cost"
              type="text"
              value={this.props.costinfo.daily_cost}
              disabled={true}
              InputProps={{
                inputComponent: NumberFormatCustom,
              }}
            />
          </Grid>
        </Grid>
  </React.Fragment>
    );
  }
}



CostDetailInfo.propTypes = {
  classes: PropTypes.object.isRequired,
};


export default (withStyles(styles)(CostDetailInfo));



// WEBPACK FOOTER //
// ./src/features/cost/DetailCostInfo.js